// extracted by mini-css-extract-plugin
module.exports = {"language":"fC","languageItem":"fD","active":"fE"};